import { createContext, FC, PropsWithChildren, useCallback, useState } from "react";

export interface AppFormProps extends PropsWithChildren {
  onFormChange: (values: any) => void;
}

export const AppFormContext: any = createContext({});



/**
 * 
 * @param param0 
 * @returns 
 */
const AppForm: FC<AppFormProps> = ({onFormChange, children}) => {

  const [values, setValues] = useState<any>({});

  const handleFormChange = useCallback((field: string, value: any) => {
    setValues((v: any) => {
      v[field] = value;
      onFormChange && onFormChange(v);
      return v;
    });
  }, [onFormChange]);

  return (<AppFormContext.Provider value={{handleFormChange}}>
    {children}
  </AppFormContext.Provider>);
}

export default AppForm;


/**
 * why
 * dont have to apply onchange on every input
 * dont have to create validations logic for every input
 * dont have to trigger validations logic on every form submit
 * single place for input or error design
 * 
 * 
 * dont have to apply debounce to every input
 */